import { nextTick } from 'vue';
import { useRouter } from 'vue-router';
// vue-router saves the scroll position in history.state when a page is left, and scrollBehavior re-applies it on
// back, but before the page's data has loaded, so the still-short page clamps it to the top. Pages call restore()
// once their data is in. A fresh visit has no saved position (`returning` is false) and restore() does nothing.
export function useRestoreScroll() {
    const saved = useRouter().options.history.state?.scroll;
    let done = false;
    return {
        returning: !!saved,
        restore() {
            if (done || !saved)
                return;
            done = true;
            nextTick(() => window.scrollTo(saved.left, saved.top));
        },
    };
}
